export default Object.freeze({
    Error: 'error',
    Warning: 'warning',
    Info: 'info',
    Success: 'success'
});
